 function toggleAccordionGeneric(header, selector) {
    const content = header.nextElementSibling;
    const icon = header.querySelector('.accordion-icon');

    // Close other accordion items in the given selector
    document.querySelectorAll(selector + ' .accordion-content').forEach((c) => {
      if (c !== content) {
        c.style.maxHeight = null;
        c.classList.remove('show');
        const otherHeader = c.previousElementSibling;
        if (otherHeader) {
          const otherIcon = otherHeader.querySelector('.accordion-icon');
          if (otherIcon) otherIcon.textContent = '+';
        }
      }
    });

    // Toggle selected accordion
    if (content.classList.contains('show')) {
      content.style.maxHeight = null;
      content.classList.remove('show');
      icon.textContent = '+';
    } else {
      content.classList.add('show');
      content.style.maxHeight = content.scrollHeight + 'px';
      icon.textContent = '−';
    }
  }

  // For regular accordions
  function toggleAccordion(header) {
    toggleAccordionGeneric(header, '');
  }

  // For cart accordions
  function toggleCartAccordion(header) {
    toggleAccordionGeneric(header, '.cart-accordion-item');
  }